export enum RawMaterialLogType {
  RECEIVED = 1,
  PRODUCTION = 2,
  PRODUCTION_UPDATE = 3,
  PRODUCTION_DELETE = 4,
  RESET = 5,
}

export const RawMaterialLogTypeLabels: Record<RawMaterialLogType, string> = {
  [RawMaterialLogType.RECEIVED]: 'Received',
  [RawMaterialLogType.PRODUCTION]: 'Production',
  [RawMaterialLogType.PRODUCTION_UPDATE]: 'Production Update',
  [RawMaterialLogType.PRODUCTION_DELETE]: 'Production Delete',
  [RawMaterialLogType.RESET]: 'Reset',
};
